import React from 'react';

import type { AssistantMessage } from '../types';
import MarkdownBody from '../MarkdownBody';

/*
 * Server-generated system update (role SYSTEM), e.g. "Compliance check
 * finished". Rendered as a distinct, centered update line rather than a bubble.
 */
const SystemMessage = ({ message }: { message: AssistantMessage }) => {
  if (!message.content) return null;
  return (
    <div className="bra-msg bra-sys">
      <div className="bra-sysbody">
        <MarkdownBody content={message.content} />
      </div>
    </div>
  );
};

export default SystemMessage;
